<template>
  <div>
    <h1 class="mb-5">{{ $t('mainPage.slogan') }}</h1>

    <section class="mb-5">
      <h4>{{ $t('mainPage.howItWorks.title') }}</h4>
      <HowToCarousel class="mb-5 px-3">
        <HowToCarouselItem class="py-3 px-4 px-sm-3 px-xl-4">
          <img src="../assets/bank.svg" class="steps-pic my-3" alt="step">
          <h5><span class="text-theme">1.</span> {{ $t('mainPage.howItWorks.step1.title') }}</h5>
          <p>{{ $t('mainPage.howItWorks.step1.text') }}</p>
        </HowToCarouselItem>
        <HowToCarouselItem class="py-3 px-4 px-sm-3 px-xl-4 step-highlighted">
          <img src="../assets/lock.svg" class="steps-pic my-3" alt="step">
          <h5><span class="text-secondary">2.</span> {{ $t('mainPage.howItWorks.step2.title') }}</h5>
          <p>{{ $t('mainPage.howItWorks.step2.text') }}</p>
        </HowToCarouselItem>
        <HowToCarouselItem class="py-3 px-4 px-sm-3 px-xl-4">
          <img src="../assets/pdf.svg" class="steps-pic my-3" alt="step">
          <h5><span class="text-theme">3.</span> {{ $t('mainPage.howItWorks.step3.title') }}</h5>
          <p>{{ $t('mainPage.howItWorks.step3.text') }}</p>
        </HowToCarouselItem>
        <HowToCarouselItem class="py-3 px-4 px-sm-3 px-xl-4">
          <img src="../assets/download.svg" class="steps-pic my-3" alt="step">
          <h5><span class="text-theme">4.</span> {{ $t('mainPage.howItWorks.step4.title') }}</h5>
          <p>{{ $t('mainPage.howItWorks.step4.text') }}</p>
        </HowToCarouselItem>
        <HowToCarouselItem class="py-3 px-4 px-sm-3 px-xl-4">
          <img src="../assets/anon.svg" class="steps-pic my-3" alt="step">
          <h5><span class="text-theme">5.</span> {{ $t('mainPage.howItWorks.step5.title') }}</h5>
          <p>{{ $t('mainPage.howItWorks.step5.text') }}</p>
        </HowToCarouselItem>
      </HowToCarousel>
    </section>

    <router-link v-if="getStarted" :to="{name: 'banks'}" class="btn btn-theme btn-sm-100 mb-2">{{ $t('mainPage.getStarted') }} →</router-link>
    <MainSubscribe v-else :title="$t('mainPage.launchingTitle')" />

    <section class="mt-5 rounded step-highlighted p-2 p-md-5">
      <h2 class="mb-2">{{$t('mainPage.api.title')}}</h2>
      <p v-html="$t('mainPage.api.text')"></p>
      <button class="btn btn-outline-theme" @click="showContactModal">{{$t('mainPage.api.button')}}</button>
      <b-modal ref="contactModal" size="lg" hide-footer :title="$t('mainPage.api.modalTitle')" id="contact">
        <div class="p-4">
          <p class="mb-5" v-if="$refs.contactForm ? !$refs.contactForm.isFormSubmitted : true" v-html="$t('mainPage.api.modalText')"></p>
          <MainContact ref="contactForm" />
        </div>
      </b-modal>
    </section>
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import HowToCarousel from '../components/HowToCarousel/HowToCarousel'
import HowToCarouselItem from '../components/HowToCarousel/HowToCarouselItem'
import MainContact from '../components/Main/MainContact.vue'
import MainSubscribe from '../components/Main/MainSubscribe.vue'

export default {
  name: 'home',
  components: {
    BModal,
    HowToCarousel,
    HowToCarouselItem,
    MainContact,
    MainSubscribe
  },
  data() {
    return {
      getStarted: true
    }
  },
  methods: {
    showContactModal() {
      this.$refs.contactModal.show()
    }
  },
  mounted() {
    const getStarted = window.localStorage.getItem('getStarted')
    if (getStarted) {
      this.getStarted = (getStarted === 'true')
    }
  }
}
</script>

<style lang="scss">
.steps-pic{
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
}
.step-highlighted{
  background-color: var(--element-bg-dark);
}
</style>
